import React, { useEffect } from "react";
import {
  Typography,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  Chip,
  Checkbox,
  TableFooter,
  TablePagination,
  Paper,
  TableContainer
} from "@mui/material";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useRowSelect,
  useSortBy,
} from "react-table";
import CssSpinner from "../Spinner/CssSpinner";

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input
          type="checkbox"
          style={{ border: "1px solid #E4E7EB" }}
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

const ProductPerfomance = ({
  columns,
  paginated = false,
  data,
  header = null,
  globalComponent = null,
  setSelectedRows,
  setShowSideNav,
  setClickedRow,
  isLoading,
  changePage,
  lastPage,
  onDataChange,
  cursorType = "pointer", 
}) => {
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const autoResetGlobalFilter = false;
  const instance = useTable(
    {
      columns,
      data,
      autoResetGlobalFilter,
    },
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!,
    useSortBy,
    useRowSelect
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { globalFilter },
    setGlobalFilter,
    selectedFlatRows,
    toggleAllRowsSelected,
  } = instance;

  const handleChangePage = (event, value) => {
    setPage(value);
    changePage(value);
    setSelectedRows([]);
    toggleAllRowsSelected(false);
  };

  useEffect(() => {
    setSelectedRows(selectedFlatRows);
  }, [selectedFlatRows]);


  return (
    <>
      {globalComponent?.(instance)}
      {isLoading ? (
        <CssSpinner />
      ) : rows.length > 0 ? (
        <Box
          sx=
          {{
            overflowX: "auto",
            mb: "5em",
          }}
        >
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table
                {...getTableProps()}
                aria-label="simple table"
                sx={{
                  mt: 0.5,
                  whiteSpace: "wrap",
                  borderTopRightRadius: "8px",
                  borderTopLeftRadius: "8px",
                  border: " 1px solid #EDF0F2",
                }}
                size="small" 
                stickyHeader
              >
                <TableHead
                  sx={{
                    borderTopRightRadius: "8px",
                    borderTopLeftRadius: "8px",
                    bgcolor: "grey.bg20",
                  }}
                >
                  {headerGroups.map((headerGroup) => (
                    <TableRow
                      {...headerGroup.getHeaderGroupProps()}
                      sx={{
                        borderTopRightRadius: "8px",
                        borderTopLeftRadius: "8px",
                      }}
                    >
                      {headerGroup.headers.map((column) => (
                        <TableCell
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          sx={{
                            textAlign: "center",
                            fontSize: "12px",
                            color: "grey.light",
                          }}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i class="las la-long-arrow-alt-up la-md"></i>
                              ) : (
                                <i class="las la-long-arrow-alt-down la-md"></i>
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody {...getTableBodyProps()}>
                  {rows.map((row, i) => {
                    prepareRow(row);
                    return (
                      <TableRow
                        onClick={() => {
                          setClickedRow(row);
                        }}
                        {...row.getRowProps()}
                        sx={{
                          bgcolor: "white",
                          cursor: cursorType,
                          "&:hover": {
                            bgcolor: "#F5F8FF",
                            borderLeft: "3px solid #2962ff",
                          },
                        }}
                      >
                        {row.cells.map((cell, idx) => {
                          return (
                            <TableCell
                              onClick={() => {
                                setShowSideNav(true);
                              }}
                              {...cell.getCellProps()}
                              sx={{
                                textAlign: "center",
                                fontSize: "14px",
                                color: "grey.main",
                              }}
                            >
                              {cell.render("Cell")}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "0.5em",
            }}
          >
            {paginated && (
              <Pagination
                sx={{
                  "& li button": { color: "grey.light", fontSize: "12px" },
                }}
                count={lastPage}
                page={page}
                onChange={handleChangePage}
                shape="rounded"
              />
            )}
          </Box>
        </Box>
      ) : (
        <Box
          marginTop={"124px"}
          display="flex"
          justifyContent={"center"}
          flexDirection="column"
          alignItems={"center"}
        >
          <img src="/assets/null-search.svg" alt="failed search" />
          <Typography
            variant="big"
            sx={{ marginBottom: "8px", marginTop: "20px" }}
          >
            No matching items
          </Typography>
          <Typography variant="small">
            No donations matching the applied filters were found. Try a
            different set or clear all filters.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ProductPerfomance;
